module.exports = __webpack_public_path__ + "static/media/md-construct.1aacb946.svg";